<template>
    <div style="height: 100%; width: 100%;">
        <div class="custom-container" >
            <v-row no-gutters justify="center">
                <v-col cols="12" md="8">
                    <v-card flat>
                        <v-card-title class="headline">
                            Neues Mitarbeitergespräch anlegen
                        </v-card-title>
                    </v-card>
                    <v-card flat v-if="!$route.params.id">
                        <v-card-title>
                            Mitarbeiter suchen
                        </v-card-title>

                        <v-card-text>
                            <v-autocomplete :disabled="disabled" placeholder="Eingabe starten um zu suchen" dense v-model="interviewed.id" :items="listUsers" @change="userChanged"/>
                        </v-card-text>
                        <AppUtilityUserCard v-if="interviewed.id" v-on:reset="interviewed = {}" :payload="interviewed"/>
                    </v-card>
                    <v-card flat class="mt-1">
                        <EmployeeInterviewsUtilityForm :interviewed_id_prob="interviewed.id"/>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['readonly', 'interview_id'],
        name: "employee-interviews-create-content",
        data: () => ({
            loaded_user_id: null,
            to_pass_user_id: null,
            users: [],
            interviewed: {},
        }),
        created() {
            var paramID = new URLSearchParams(window.location.search).get('id');
            if (paramID){
                this.axios.get('/users/' + paramID).then( (response) => {
                    this.interviewed = {...response.data.data};
                }).catch( () => {
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
                    this.$router.push({ name: 'EmployeeInterviewsDashboard'});
                });
            }
        },
        computed: {
            listUsers(){
                return this.users.map(item => {
                    return {
                        value: item.id,
                        text: item.last_name + ', ' + item.first_name + '(' + item.staff_number + ')'
                    };
                });
            },
            disabled(){
                return !!this.interviewed.id;
            }
        },
        mounted() {
            this.getUsers();
        },
        methods: {
            getUsers(){
                this.axios.get('/users?type=list').then( (response) => {
                    this.users = Object.values({...response.data.data.users});
                });
            },
            userChanged(){
                this.to_pass_user_id = this.loaded_user_id;
                this.getUser();
            },
            getUser(){
                this.axios.get('/users/' + this.interviewed.id).then( (response) => {
                    this.interviewed = {...response.data.data};
                });
            }
        }

    }
</script>

<style scoped>

</style>